import ugr from '@/UGRoute';
import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
const PublicRoute = () => {
    const isLoggedIn = localStorage.getItem('fullName');    
    if (!isLoggedIn) {
        return <Outlet />
    } else {
        return <Navigate to={`/${ugr}/dashboard`} />
    }


}
export default PublicRoute